import { render, staticRenderFns } from "./addressbook.vue?vue&type=template&id=4e54ded2&scoped=true&"
import script from "./addressbook.vue?vue&type=script&lang=js&"
export * from "./addressbook.vue?vue&type=script&lang=js&"
import style0 from "./addressbook.vue?vue&type=style&index=0&id=4e54ded2&scoped=true&lang=scss&"
import style1 from "./addressbook.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54ded2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VRow,VTextField,VTooltip})
